export function isUnlimited(limit: number | null | undefined): limit is number {
  return limit === -1;
}
